export enum ModelScreenerFieldType {
  Currency = "Currency",
  CurrencyText = "CurrencyText",
  DateTime = "DateTime",
  Percentage = "Percentage",
  PercentageText = "PercentageText",
  TextShort = "TextShort",
  YesNo = "YesNo",
  TextLong = "TextLong",
  Number = "Number",
  NumberText = "NumberText",
  Link = "Link",
  Image = "Image",
  Manager = "Manager",
  Dropdown = "Dropdown",
}
